import type { PortfolioContextEntry, UUID } from '~/types';

export type PortfolioCompanyGroup = {
  parentCompanyId: UUID | null;
  portfolios: PortfolioContextEntry[];
};

export function groupPortfoliosByCompany(
  portfolios: PortfolioContextEntry[]
): PortfolioCompanyGroup[] {
  const groups = new Map<UUID | null, PortfolioCompanyGroup>();

  for (const portfolio of portfolios) {
    const { parent_company_id: parentCompanyId } = portfolio;
    const group = groups.get(parentCompanyId);
    if (group) {
      group.portfolios.push(portfolio);
    } else {
      groups.set(parentCompanyId, { parentCompanyId, portfolios: [portfolio] });
    }
  }

  return Array.from(groups.values());
}
